import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Observable, Observer, merge, fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class NetworkStatusService {
    private networkStatus = new Subject<boolean>();

    constructor() {
        this.init();
    }

    get isOnline$ () {
        return this.networkStatus.pipe(
            filter(Boolean)
        );
    }

    private  online$: Observable<Event>;

    public init() {
        this.online$ = fromEvent(window, 'online');

        this.online$.subscribe(e => {
            this.networkStatus.next(true);
        });
    }


}